export default __webpack_public_path__ + "static/N0118-645f178c8568b73f13f0e752c41095b1.png";